import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { RESIZE_URL } from 'utils/restapi';
import {
  fetchImageSlidersList,
  addImagesToSlider,
  clearAddImagesToSlider,
  deleteImageFromSlider,
  clearDeleteImageFromSlider,
} from 'redux/image-sliders/actions';

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";

import CommonImageDropzone from 'components/common/CommonImageDropzone';
import CommonMessage from 'components/common/CommonMessage';
import Button from 'components/elements/buttons/Button';
import { Link } from "react-router-dom";

import './ImageSliderDropzone.css';


class ImageSliderDropzone extends Component {
  static propTypes = {
    fetchImageSlidersList: PropTypes.func.isRequired,
    addImagesToSlider: PropTypes.func.isRequired,
    clearAddImagesToSlider: PropTypes.func.isRequired,
    deleteImageFromSlider: PropTypes.func.isRequired,
    me: PropTypes.object,
    item: PropTypes.object.isRequired,
    addImageSuccess: PropTypes.object,
    addImagesError: PropTypes.object,
    deleteImageSuccess: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    addImageSuccess: null,
    addImagesError: null,
    deleteImageSuccess: null,
  };

  componentDidUpdate(prevProps) {
    // Add Image
    if (!prevProps.addImagesSuccess && this.props.addImagesSuccess) {
      this.props.fetchImageSlidersList();
      this.props.clearAddImagesToSlider();
    }

    // Delete Image
    if (!prevProps.deleteImagesSuccess && this.props.deleteImagesSuccess) {
      this.props.fetchImageSlidersList();
      this.props.clearDeleteImageFromSlider();
    }

    // Reorder Image
  }

  componentWillUnmount() {
    this.props.clearAddImagesToSlider();
    this.props.clearDeleteImageFromSlider();
  }

  onImageDrop = droppedImages => {
    const form = new FormData();
    this.props.item.media_items && this.props.item.media_items.length > 0 &&
      this.props.item.media_items.forEach(item => (
        form.append('images', item.id)
      ));
    droppedImages.forEach(item => (
      form.append('images', item.imageBlob, item.name)
    ));
    this.props.addImagesToSlider(this.props.item.id, form);
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onReorderEnd = result => {
    if (!result.destination) {
      return;
    }

    const reorderedItems = this.reorder(
      this.props.item.media_items,
      result.source.index,
      result.destination.index
    );

    const form = new FormData();
    reorderedItems.forEach(item => form.append('images', item.id));
    this.props.addImagesToSlider(this.props.item.id, form);
  };

  renderImagesList = () => (
    <DragDropContext onDragEnd={this.onReorderEnd}>
      <Droppable droppableId="droppable">
        {provided => (
          <div
            className="droppable-container"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {this.props.item.media_items && this.props.item.media_items.map((item, index) => (
              <Draggable
                key={`${item.id}`}
                draggableId={`${item.id}`}
                index={index}
              >
                {provided => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <div
                      className="image"
                      style={{ backgroundImage: item.image &&
                        `url(${RESIZE_URL}/cdn-cgi/image/f=auto,q=85,fit=crop,w=90/${item.image})` }}
                    >
                      <div
                        className="delete-icon"
                        onClick={() =>{
                          this.props.deleteImageFromSlider(item.id);
                          this.props.clearAddImagesToSlider();
                        }}
                        role="button"
                        tabIndex={-1}
                      />
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );

  calculateAspectRatio = () => {
    if (this.props.item.image_size === 'SQ') {
      return 1 / 1;
    }
    if (this.props.item.image_size === 'HR') {
      return 4 / 3;
    }
    if (this.props.item.image_size === 'VR') {
      return 3 / 4;
    }
    return 1 / 1;
  };

  render() {
    const { item, addImagesError } = this.props;

    return (
      <Translation>
        {(t) => (
          <div className="image-slider-dropzone__component">
            <div className="dropzone-wrapper">
              {/* Dropzone */}
              <CommonImageDropzone
                onDropImage={this.onImageDrop}
                className="upload-dropzone"
                modalClassName="image-slider-upload-dropzone"
                multiple
                maxFiles={6}
                aspectRatio={this.calculateAspectRatio()}
              >
                <div className="dropzone-text">
                  {t("Drop your images here, or just")} <span>{t("Browse")}</span> {t("your local storage")}
                </div>
                {!(item && item.media_items && item.media_items.length > 0) &&
                  <div className="buttons-block">
                    <div className="arrow-block">
                      <div className="text-block">
                        {t("Click to")} <strong>{t("Add image")}</strong>
                      </div>
                      <div className="arrow" />
                    </div>
                    <Button>+ {t("Add Image")}</Button>
                  </div>
                }
              </CommonImageDropzone>

              {/* Images Container */}
              <div className="images-container">
                {this.renderImagesList()}
              </div>
            </div>

            {addImagesError &&
              <CommonMessage error>
                {t("You can add more than 2 images on the PRO plan.")}
                {t("Check it")} <Link to="/billing">{t("here")}</Link>
              </CommonMessage>
            }
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    addImagesSuccess: state.imageSlidersReducer.addImagesSuccess,
    addImagesError: state.imageSlidersReducer.addImagesError,
    deleteImagesSuccess: state.imageSlidersReducer.deleteImagesSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchImageSlidersList,
    addImagesToSlider,
    clearAddImagesToSlider,
    deleteImageFromSlider,
    clearDeleteImageFromSlider,
  },
)(ImageSliderDropzone);
